import React from 'react';
import WorkspaceItemContext from '../../../app/contexts/workspace/workspace-item-context';

export default function useDrawingObjectLayer() {
    return React.useContext(WorkspaceItemContext).drawingObjectsLayer;
}
